<template>
  <div class="c-wine">
    <div class="c-wine__banner" :class="'c-wine_' + item.color">
      <div class="c-wine__name">{{ `${item.name} - ${item.data.vintage}` }}</div>
      <img class="c-wine__label" :src="$store.getters.getLabelUrl(item)"/>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { WINE_READ } from '@/store/actions/wine';


export default {
  name: 'Wine',

  props: {
    wineId: Number
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapState({
      item: state => state.wine.wine
    })
  },

  mounted () {
    this.fetchData();
  },

  watch: {
    'wineId': function () {
      this.fetchData();
    }
  },

  methods: {
    fetchData () {
      this.loading = true;

      this.$store.dispatch(WINE_READ, this.wineId)
        .catch(e => {
          this.$log.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.c-wine {
  position: relative;

  &__banner {
    position: relative;
    width: 80%;
    left: 10%;
    height: 40px;
    margin-top: 50px;
    margin-bottom: 50px;
    padding-left: 50px;
  }

  &__name {
    font-weight: bold;
    text-transform: capitalize;
  }

  &__label {
    position: absolute;
    width: 100px;
    height: 100px;
    object-fit: contain;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -50px;
  }

  &_red {
    background-color: $wine-red;
  }

  &_rose {
    background-color: $wine-rose;
  }

  &_white {
    color: black;
    background-color: $wine-white;
  }
}
</style>
